import { AppCard } from './AppCard'
import { useEntitlements } from '../../hooks/useEntitlements'
import { appConfigs } from './utilities/appOptions'
import { CustomErrorComponent } from '../Shared/CustomErrorComponent'
import { useActiveEnvironment } from '../../hooks/useEnvironments'

interface AppCardsDisplayProps {
  onAnyAction?: () => void
  className?: string
}

export const AppCardsDisplay = ({ onAnyAction, className = '' }: AppCardsDisplayProps) => {
  const { hasEntitlement } = useEntitlements()
  const { environment } = useActiveEnvironment()
  const portal = hasEntitlement('portalEnabled')
  const projects = hasEntitlement('projectsEnabled')
  const custom = hasEntitlement('customAppsEnabled')
  const autobuild = hasEntitlement('autobuild') && !environment?.isProd
  const flatfileOs = hasEntitlement('flatfileOsProject')

  const allowedApps = appConfigs.filter(
    (app) =>
      (app.id === 'portal' && portal) ||
      (app.id === 'projects' && projects) ||
      (app.id === 'custom' && custom) ||
      (app.id === 'autobuild' && autobuild) ||
      (app.id === 'flatfileOs' && flatfileOs)
  )

  if (allowedApps.length === 0) {
    return (
      <div className='col-span-12'>
        <CustomErrorComponent
          page='AppCardsDisplay.tsx'
          message='There are no apps enabled on your account. Please reach out to support'
          doNotCenter
        />
      </div>
    )
  }

  return (
    <div className={`flex flex-row gap-6 pb-4 min-w-min ${className}`}>
      {allowedApps.map((app) => (
        <div key={app.id} className='flex-shrink-0 w-[320px]'>
          <AppCard app={app} onAnyAction={onAnyAction} />
        </div>
      ))}
    </div>
  )
}
